module.exports = __webpack_public_path__ + "img/code.c38c6a87.png";